<template>
  <div class="orders-list">
    <div class="result-filter flex flex-between align-center">

      <div class="filters flex">

        <div class="form-field date">
            <label for="">Filter date range</label>
            <input type="date" v-model="payload.date_from" @change="loadOrders" />
        </div>
        <div class="to">
          to
        </div>
        <div class="form-field date">
          <label for="">&nbsp;</label>
          <input type="date" v-model="payload.date_to" @change="loadOrders" />
        </div>
      </div>

    </div>

    <div class="orders">

      <div class="row title flex">
        <div class="order">
          ORDER NO.
        </div>
        <div class="date">
          DATE
        </div>
        <div class="amount">
          AMOUNT
        </div>
      </div>
      <div
        v-for="order of orders"
        :key="order.id"
        class="row flex"
      >
          <div class="order">
            <a :href="'/order-detail/' + order.id">{{ order.id }}</a>
          </div>
          <div class="date">{{ order.created_at }}</div>
          <div class="amount">{{ modFormatDollarAmount(order.total) }}</div>
      </div>

      <div v-if="orders.length == 0">
        <h4>No Order History</h4>
      </div>

    </div>

    <app-pagination 
      :pagination="pagination"
      v-on:setPage="setPage"
    ></app-pagination>
    
  </div>
</template>

<script>
export default {
  data () {
    return {
      orders: [],
      sortOrder: 'a-z',
      sortOptions: [
        { label: 'A-Z', value: 'a-z' },
        { label: 'Z-A', value: 'z-a' },
        { label: 'Lowest Price', value: 'lowest' },
        { label: 'Highest Price', value: 'highest' },
      ],
      payload: {
        date_to: '',
        date_from: '',
        sort_field: '',
        sort_order: ''
      },
      pagination: {
        current_page: 1,
        from: 1,
        last_page: 1,		    
        per_page: 12,
        to: 1,
        total: 0,
      }
    }
  },

  mounted () {
    this.loadOrders()
  },

  methods: {    
    setPage (page) {
      this.pagination.current_page = page
      this.loadOrders()
    },

    loadOrders () {
      let url = '/api/orders?page=' + this.pagination.current_page + '&per_page=' + this.pagination.per_page
      url += '&sortby=' + this.sortOrder
      
      if (this.payload.date_from) {
        url += '&date_from=' + this.payload.date_from  
      }
      
      if (this.payload.date_to) {
        url += '&date_to=' + this.payload.date_to  
      }
      // ?date_to=2021-11-02&date_from=2021-11-02&sort_field=order_no&sort_order=latest
      this.$store.commit('setLoading', true)
      
      window.axios.get(url)
        .then(response => {
          this.orders = response.data.data
          this.pagination = response.data.meta
          
          this.$store.commit('setLoading', false)
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-order/OrderHistory.vue